import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import fileDownload from "js-file-download";
import axios from "axios";
import { SERVER_URL } from "src/serverConfig";
import {clientAPI} from "./axiosAnstance";

export const downloadAdherentsDataAPI = createAsyncThunk(
  "statistiques/exportData",
  async () => {
    let token = localStorage.getItem("token");
    const d = new Date();
    var datestring =
      ("0" + d.getDate()).slice(-2) +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      d.getFullYear() +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2);

    return axios
      .get(SERVER_URL + `/api/statistiques/export-data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, `données-adhérents-${datestring}.xlsx`);
      });
  }
);
export const downloadDataOncfAPI = createAsyncThunk(
  "statistiques/exportDataOncf",
  async () => {
    let token = localStorage.getItem("token");
    const d = new Date();
    var datestring =
      ("0" + d.getDate()).slice(-2) +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      d.getFullYear() +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2);

    return axios
      .get(SERVER_URL + `/api/statistiques/export-data-oncf`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, `données-adhérents-${datestring}.xlsx`);
      });
  }
);

export const listAdherentFilterAPI = createAsyncThunk(
  "statistiques/listAdherentFilterAPI",
  async (data) => {
    const response = await clientAPI.post("/api/export/filter", data);

    return response.data;
  }
);

export const listAdherentByGenreAPI = createAsyncThunk(
  "statistiques/listAdherentByGenreAPI",
  async () => {
    //console.log('Data envoyée pour filtre :: ');
    const response = await clientAPI.get("/api/statistiques/adherents-par-genre");

    return response.data;
  }
);

export const prestationParStatut = createAsyncThunk(
  "statistiques/prestationParStatut",
  async () => {
    //console.log('Data envoyée pour filtre :: ');
    const response = await clientAPI.get("/api/statistiques/prestationParStatut");

    return response.data;
  }
);

export const listAdherentByGenreEnfantAPI = createAsyncThunk(
  "statistiques/listAdherentByGenreEnfantAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/adherents-par-genreEnfant");
    return response.data;
  }
);

export const listAdherentByStatutAPI = createAsyncThunk(
  "statistiques/listAdherentByStatutAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/adherents-par-statut");
    return response.data;
  }
);

export const listAdherentByRegionAPI = createAsyncThunk(
  "statistiques/listAdherentByRegionAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/adherents-par-region");

    return response.data;
  }
);
export const listEnfantByRegionAPI = createAsyncThunk(
  "statistiques/listEnfantByRegionAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/adherents-par-regionEnfant");

    return response.data;
  }
);
export const listFamilleAPI = createAsyncThunk(
  "statistiques/listFamilleAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/famille");

    return response.data;
  }
);
export const listAdherentByAffectationAPI = createAsyncThunk(
  "statistiques/listAdherentByAffectationAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/adherents-par-affectation");

    return response.data;
  }
);
export const listAdherentByTrancheAPI = createAsyncThunk(
  "statistiques/listAdherentByTrancheAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/adherents-par-tranche_age");
    return response.data;
  }
);
export const listAdherentByTrancheEnfantsAPI = createAsyncThunk(
  "statistiques/listAdherentByTrancheEnfantsAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/adherents-par-tranche_age_enfant");
    return response.data;
  }
);
export const listStatutAdherentCreateCompteAPI = createAsyncThunk(
  "statistiques/listStatutAdherentCreateCompteAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/statutAdherentCreateCompte");
    return response.data;
  }
);
export const nombreAdherentAPI = createAsyncThunk(
  "statistiques/nombreAdherentAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/nombreAdherent");

    return response.data;
  }
);
export const nombreEnfantAPI = createAsyncThunk(
  "statistiques/nombreEnfantAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/nombreEnfant");
    return response.data;
  }
);


export const nombreCompteAPI = createAsyncThunk(
  "statistiques/nombreCompteAPI",
  async () => {
    const response = await clientAPI.get("/api/statistiques/nombreCompte");
    return response.data;
  }
);
export const downloadNombreByGradeAndStatutAPI = createAsyncThunk(
  "statistiques/downloadNombreByGradeAndStatutAPI",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      //console.log("Le token est ::: ", token);

      const response = await axios.get(`${SERVER_URL}/api/statistiques/exportByGradeAndStatut`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob", // important pour les fichiers binaires
      });

      fileDownload(response.data, "Adherent_Grade_Statut.xlsx");
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);
export const getMontantTotalPrestationAPI = createAsyncThunk(
  "statistiques/getMontantTotal",
  async (paramId, thunkAPI) => {
    try {
      // Adaptez l'URL selon votre Controller Java
      const response = await clientAPI.get(`/api/statistiques/montant-total/${paramId}`);
      return response.data || 0; // Retourne 0 si null
    } catch (error) {
      return 0; // Fallback sécurité
    }
  }
);
export const getEnfantSoutientScolaireByPrestationAPI = createAsyncThunk(
  "statistiques/getEnfantSoutientScolaireByPrestationAPI",
  async (paramId, thunkAPI) => {
    try {
      // Adaptez l'URL selon votre Controller Java
      const response = await clientAPI.get(`/api/statistiques/enfant/${paramId}`);
      console.log('le nombre d enfant valid :  ',response.data)
      return response.data || 0; // Retourne 0 si null
    } catch (error) {
      return 0; // Fallback sécurité
    }
  }
);
const StatistiquesSlice = createSlice({
  name: "statistiques",
  initialState: {
    details: {},
    famille: {},
    adherentsList: [],
    prestationStatut: [],
    montantTotalPrestation: 0,
    loadingPrestation: false,
    adherentsParGenre: [],
    enfantParGenre: [],
    adherentsParStatut: [],
    adherentsParStatutCreate: [],
    trancheAge: [],
    trancheAgeEnfant: [],
    nombreAdherent:0,
    nombreEnfant:0,
    nombreCompte:0,
    enfantSoutientScolaire:0,
    adherentsParRegion: [],
    enfantParRegion: [],
    adherentsParAffectation: [],
    loading: false,
    loadingStatut: false,
    totalRows: 0,

  }, // enfants: []
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(prestationParStatut.pending, (state) => {
        state.loadingPrestation = true;
      })
      .addCase(prestationParStatut.fulfilled, (state, action) => {
        state.loadingPrestation = false;
        state.prestationStatut = action.payload;
      })
      // Gestion du Montant Total
      .addCase(getMontantTotalPrestationAPI.fulfilled, (state, action) => {
        state.montantTotalPrestation = action.payload;
      })
      .addCase(getEnfantSoutientScolaireByPrestationAPI.fulfilled, (state, action) => {
        state.enfantSoutientScolaire = action.payload;
      })
      .addCase(listAdherentFilterAPI.fulfilled, (state, action) => {
        state.adherentsList = action.payload.data;
        state.totalRows = action.payload.totalRows;
      })
      // tranche age ______________________________________________________
      .addCase(listAdherentByTrancheAPI.fulfilled, (state, action) => {
        state.loadingStatut = false;
        state.trancheAge = action.payload
      })
      .addCase(listAdherentByTrancheEnfantsAPI.fulfilled, (state, action) => {
        state.loadingStatut = false;
        state.trancheAgeEnfant = action.payload;
      })
      //nombre adherents ___________________________________________________
      .addCase(nombreAdherentAPI.fulfilled, (state, action) => {
        state.nombreAdherent = action.payload;
      })
      .addCase(listFamilleAPI.fulfilled, (state, action) => {
        state.famille = action.payload;
      })
      .addCase(nombreEnfantAPI.fulfilled, (state, action) => {
        state.nombreEnfant = action.payload;
      })
      .addCase(nombreCompteAPI.fulfilled, (state, action) => {
        state.nombreCompte = action.payload;
      })
      //Affectation _______________________________________________________
      .addCase(listAdherentByAffectationAPI.pending, (state) => {
        state.loadingStatut = true;
        state.error = null;
      })
      .addCase(listAdherentByAffectationAPI.fulfilled, (state, action) => {
        state.loadingStatut = false;
        state.adherentsParAffectation = action.payload;
      })
      .addCase(listAdherentByAffectationAPI.rejected, (state, action) => {
        state.loadingStatut = false;
        state.error = action.error.message;
      })
      //___________________________________________________________________
      //region ___________________________________________________________
      .addCase(listAdherentByRegionAPI.pending, (state) => {
        state.loadingStatut = true;
        state.error = null;
      })
      .addCase(listAdherentByRegionAPI.fulfilled, (state, action) => {
        state.loadingStatut = false;
        state.adherentsParRegion = action.payload;
      })
      .addCase(listEnfantByRegionAPI.fulfilled, (state, action) => {
        state.loadingStatut = false;
        state.enfantParRegion = action.payload;
      })
      .addCase(listAdherentByRegionAPI.rejected, (state, action) => {
        state.loadingStatut = false;
        state.error = action.error.message;
      })
      //___________________________________________________________________
      // statut ___________________________________________________________
      .addCase(listAdherentByStatutAPI.pending, (state) => {
        state.loadingStatut = true;
        state.error = null;
      })
      .addCase(listAdherentByStatutAPI.fulfilled, (state, action) => {
        state.loadingStatut = false;
        state.adherentsParStatut = action.payload;
      })
      .addCase(listStatutAdherentCreateCompteAPI.fulfilled, (state, action) => {
        state.loadingStatut = false;
        state.adherentsParStatutCreate = action.payload;
      })
      .addCase(listAdherentByStatutAPI.rejected, (state, action) => {
        state.loadingStatut = false;
        state.error = action.error.message;
      })
      // genre ____________________________________________________________
      .addCase(listAdherentByGenreAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listAdherentByGenreAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.adherentsParGenre = action.payload;
      })
      .addCase(listAdherentByGenreEnfantAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.enfantParGenre = action.payload;
      })
      .addCase(listAdherentByGenreAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      //_____________________________________________________

      .addCase(downloadAdherentsDataAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadAdherentsDataAPI.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(downloadAdherentsDataAPI.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default StatistiquesSlice.reducer;
